(()=>{
  if(!document.body.classList.contains('hmb-preview'))return;
  let gesture=null,blockedViewer=null,swipedAt=0;
  const locate=target=>{
    const viewer=target.closest?.('.product__media-wrapper .product__media-list,.st__hero,.aw__hero');
    if(!viewer||target.closest('.st__nav,.aw__nav'))return null;
    if(viewer.classList.contains('product__media-list')){
      const active=target.closest('.product__media-item');
      if(!active?.querySelector('.product__modal-opener--image'))return null;
    }
    return viewer;
  };
  const finish=(x,y)=>{
    const active=gesture;gesture=null;
    if(!active||!active.viewer.isConnected)return;
    const dx=x-active.x,dy=y-active.y;
    if(Math.abs(dx)<35||Math.abs(dx)<Math.abs(dy)*1.25)return;
    const viewer=active.viewer;
    if(viewer.classList.contains('product__media-list')){
      const gallery=viewer.closest('media-gallery');
      const items=Array.from(viewer.querySelectorAll(':scope>.product__media-item[data-media-id]')).filter(item=>{
        if(!item.querySelector('.product__modal-opener--image'))return false;
        const thumb=gallery.querySelector('[data-target="'+item.dataset.mediaId+'"]');
        return !thumb||getComputedStyle(thumb).display!=='none';
      });
      const current=items.findIndex(item=>item.classList.contains('is-active'));
      if(items.length<2||current<0||typeof gallery.setActiveMedia!=='function')return;
      const next=items[(current+(dx<0?1:-1)+items.length)%items.length];
      gallery.setActiveMedia(next.dataset.mediaId,false);
    }else{
      const root=viewer.closest('.st,.aw'),thumbs=Array.from(root.querySelectorAll('.st__thumb,.aw__thumb'));
      if(thumbs.length<2)return;
      const current=Math.max(0,thumbs.findIndex(thumb=>thumb.classList.contains('is-on')));
      thumbs[(current+(dx<0?1:-1)+thumbs.length)%thumbs.length].click();
    }
    blockedViewer=viewer;swipedAt=Date.now();
  };
  if('PointerEvent' in window){
    document.addEventListener('pointerdown',event=>{
      if(!event.isPrimary){gesture=null;return;}
      if(event.pointerType==='mouse'&&event.button!==0)return;
      const viewer=locate(event.target);
      if(!viewer)return;
      if(event.pointerType!=='mouse'&&!viewer.classList.contains('product__media-list'))return;
      gesture={viewer,x:event.clientX,y:event.clientY,id:event.pointerId};
    },true);
    document.addEventListener('pointermove',event=>{
      if(!gesture||gesture.id!==event.pointerId)return;
      const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
      if(Math.abs(dx)>12&&Math.abs(dx)>Math.abs(dy)*1.25&&event.cancelable)event.preventDefault();
    },{capture:true,passive:false});
    document.addEventListener('pointerup',event=>{if(gesture?.id===event.pointerId)finish(event.clientX,event.clientY);},true);
    document.addEventListener('pointercancel',()=>{gesture=null;},true);
  }else{
    document.addEventListener('touchstart',event=>{
      const viewer=locate(event.target);
      gesture=viewer?.classList.contains('product__media-list')&&event.touches.length===1?{viewer,x:event.touches[0].clientX,y:event.touches[0].clientY}:null;
    },{capture:true,passive:true});
    document.addEventListener('touchend',event=>{if(event.changedTouches.length)finish(event.changedTouches[0].clientX,event.changedTouches[0].clientY);},{capture:true,passive:true});
    document.addEventListener('touchcancel',()=>{gesture=null;},{capture:true,passive:true});
  }
  document.addEventListener('dragstart',event=>{if(locate(event.target))event.preventDefault();},true);
  document.addEventListener('click',event=>{
    if(blockedViewer?.contains(event.target)&&Date.now()-swipedAt<600){event.preventDefault();event.stopImmediatePropagation();}
  },true);
})();
